export default "__VITE_ASSET__Dd$5JpYe__"